import { render, staticRenderFns } from "./ImportarAprovacoes.vue?vue&type=template&id=bf27572e&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarAprovacoes.vue?vue&type=style&index=0&id=bf27572e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf27572e",
  null
  
)

export default component.exports